import React from 'react';
export default function Modal(_ref) {
  var visible = _ref.visible,
    closeModal = _ref.closeModal,
    styles = _ref.styles,
    mode = _ref.mode,
    icon = _ref.icon,
    children = _ref.children,
    elementsClass = _ref.elementsClass,
    abortText = _ref.abortText,
    abortAction = _ref.abortAction,
    saveText = _ref.saveText,
    acceptAction = _ref.acceptAction,
    theme = _ref.theme,
    disabledAction = _ref.disabledAction;
  return /*#__PURE__*/React.createElement(React.Fragment, null, visible && /*#__PURE__*/React.createElement("div", {
    className: "modal-wrapper flex-box content-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-overlay",
    onClick: closeModal
  }), /*#__PURE__*/React.createElement("div", {
    className: "modal-content flex-box items-start flex-column ".concat(mode || '')
  }, closeModal && /*#__PURE__*/React.createElement("div", {
    className: "modal-close ".concat(theme || '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "close_icon flex-box items-center content-center",
    onClick: closeModal
  })), /*#__PURE__*/React.createElement("div", {
    className: "modal-body flex-box flex-column ".concat(elementsClass || '', " ").concat(theme || ''),
    style: styles || {}
  }, icon && /*#__PURE__*/React.createElement("div", {
    className: "flex-box items-center content-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(icon, "_icon icon")
  })), children), /*#__PURE__*/React.createElement("div", {
    className: "modal-actions flex-box items-center content-center ".concat(theme || '')
  }, abortAction && /*#__PURE__*/React.createElement("div", {
    className: "button inverted",
    onClick: abortAction
  }, abortText), acceptAction && /*#__PURE__*/React.createElement("div", {
    className: "button ".concat(disabledAction ? 'disabled' : ''),
    onClick: disabledAction ? function () {} : acceptAction
  }, saveText)))));
}